import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, styled, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";
import useAuth from "../../../hooks/useAuth";
import { useCreateCoreFocusAreaMutation, useFetchCoreFocusAreasQuery } from "../../../services/roleReviewService";
import { Link, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
const ErrorText = styled("div")`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;
// --------------------------- without modify corefocus area name --------------------------- 
// const validationSchema = yup.object().shape({
//   coreFocusAreas: yup
//     .array()
//     .of(
//       yup.object().shape({
//         area: yup.string().required("Core Focus Area is required"),
//         timeSpent: yup
//           .number()
//           .typeError("Time Spent must be a valid number")
//           .min(0, "Time spent must be at least 0")
//           .max(100, "Time spent cannot exceed 100")
//           .required("Time Spent is required"),
//         importance: yup
//           .number()
//           .typeError("Importance must be a valid number")
//           .min(0, "Importance must be at least 0")
//           .max(100, "Importance cannot exceed 100")
//           .required("Importance is required"),
//       })
//     )
//     .required("At least one Core Focus Area is required"),
// });

// const Step2 = ({ currentStep, onNext,onPrev }) => {
//   const {users} = useAuth()
//   // const employeeId=users?.data?.user_id
  
//   // const userId=useParams();
//   const { id: param } = useParams();

 
//  const [employeeId, setEmployeeId] = useState(null);
//   useEffect(() => {
//     if (users?.role === "manager") {
//       if (param.includes(".")) {
//         try {
//           const decoded = jwtDecode(param); // Decode JWT token
//           setEmployeeId(decoded?.user_id); // Set employeeId in state
//           console.log(decoded?.user_id); // Extract user ID from token
//         } catch (error) {
//           console.error("Invalid token:", error);
//           setEmployeeId(null);
//         }
//       } else {
//         setEmployeeId(param); // If not a token, use the param as employee ID
//       }
//     } else {
//       setEmployeeId(users?.user_id); // Use logged-in user ID for non-managers
//     }
//   }, [users, param]);
//   console.log(employeeId)
//   const { data: fetchedData,refetch:corefocus_details } = useFetchCoreFocusAreasQuery(employeeId, {
//     skip: !employeeId, // Skip API call if employeeId is not set
//   });
  
  
  
//   // console.log("coreFousData",coreFousData)
//   const [createCoreFocusArea] = useCreateCoreFocusAreaMutation();
//   const {
//     register,
//     handleSubmit,
//     control,
//     setValue,
//     reset,
//     watch,
//     formState: { errors },
//   } = useForm({
//     mode: "onChange",
//     defaultValues: {
//       coreFocusAreas: [{ area: "", timeSpent: "", importance: "" },{ area: "", timeSpent: "", importance: "" },{ area: "", timeSpent: "", importance: "" }],
      
//       // coreFocusAreas: [],
//     },
//     resolver: yupResolver(validationSchema),
//   });
//   const { append, fields ,remove} = useFieldArray({
//     control,
//     name: "coreFocusAreas",
//   });
//   useEffect(() => {
//     if (fetchedData) {
     
//       reset({
//         coreFocusAreas: [], 
//       });
  
//       const coreFocusArray = fetchedData?.data;
//       if (coreFocusArray) {
//         console.log("Fetched Core Focus Areas:", fetchedData);
//         const transformedData = coreFocusArray.map((area) => ({
//           area: area.area || "", 
//           timeSpent: area.time_spent || 0, 
//           importance: area.importance || 0, 
//         }));
//         console.log("transformedData",transformedData);
        
  
//         // Append transformed data to the form
//         transformedData.forEach((data) => append(data));
//       } else {
//         console.error("Fetched data is not in expected array format:", fetchedData);
//       }
//     }
//   }, [fetchedData, append, setValue, reset]);
  
//   // Trigger refetch manually when needed
//   useEffect(() => {
//     console.log(currentStep);
    
//     if (currentStep === 2 && employeeId) {
//       corefocus_details(); // Refetch data if employeeId is set
//     }
//   }, [currentStep,employeeId, corefocus_details]);
  

 

//   //   const onSubmit = () => {
//   //     onNext();
//   //   };
//   const onSubmit = async(data) => {
//     const coreFocusAreas = watch("coreFocusAreas");
//     const totalTimeSpent = coreFocusAreas.reduce(
//         (sum, area) => sum + (parseFloat(area.timeSpent) || 0),
//         0
//     );
//     const totalImportance = coreFocusAreas.reduce(
//         (sum, area) => sum + (parseFloat(area.importance) || 0),
//         0
//     );
//     // If timeSpent or importances is higher than 100 then don't send data
//     if (totalTimeSpent > 100 || totalImportance > 100) {
//       console.warn("Total time spent or importance exceeds 100%");
//       // Do not submit the form
//       return;
//     }
//     if (totalTimeSpent < 100 || totalImportance < 100) {
//       console.warn("Total time spent or importance under 100%");
//       // Do not submit the form
//       return;
//     }
  
//     // Check if total time spent exceeds 100
    
//     const transformedData = data.coreFocusAreas.map(area => ({
//       area: area.area,
//       user_id: employeeId,  // Assuming userId is passed as a prop
//       time_spent: area.timeSpent,
//       importance: area.importance,
//     }));
//     const response = await createCoreFocusArea(transformedData);

//     // console.log("corefocus created successfully:", response);
//     // console.log("coreFocusAreas", data.coreFocusAreas);
//     const coreFocusAreasData= response.data?.data
    
    
//     onNext({ coreFocusAreas: coreFocusAreasData });
//     // console.log("Core Focus Area Created with ID:", response.map(area => area.id));
//     // onNext({ coreFocusAreas: data.coreFocusAreas });
//   };
//   const saveDataToBackend = async () => {
//     const coreFocusAreas = watch("coreFocusAreas");
//     const transformedData = coreFocusAreas.map((area) => ({
//       area: area.area,
//       user_id: employeeId,
//       time_spent: area.timeSpent,
//       importance: area.importance,
//     }));

//     try {
//       await createCoreFocusArea(transformedData);
//       console.log("Core Focus Areas saved to backend successfully");
//     } catch (error) {
//       console.error("Error saving Core Focus Areas:", error);
//     }
//   };
//   const handlePrevious = async () => {
//     await saveDataToBackend();
//     onPrev(); // Move to the previous step without passing form data
//   };
// --------------------------- without modify corefocus area name --------------------------- 
// ++++++++++++++++++++++++++++ with modify corefocus area name ++++++++++++++++++++++++++++
const validationSchema = yup.object().shape({
  coreFocusAreas: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.mixed().nullable(), // allow null or number
        area: yup.string().required("Core Focus Area is required"),
        timeSpent: yup
          .number()
          .typeError("Time Spent must be a valid number")
          .min(0, "Time spent must be at least 0")
          .max(100, "Time spent cannot exceed 100")
          .required("Time Spent is required"),
        importance: yup
          .number()
          .typeError("Importance must be a valid number")
          .min(0, "Importance must be at least 0")
          .max(100, "Importance cannot exceed 100")
          .required("Importance is required"),
      })
    )
    .required("At least one Core Focus Area is required"),
});

const Step2 = ({ currentStep, onNext, onPrev }) => {
  const { users } = useAuth();
  const { id: param } = useParams();
  const [employeeId, setEmployeeId] = useState(null);

  useEffect(() => {
    if (users?.role === "manager") {
      if (param.includes(".")) {
        try {
          const decoded = jwtDecode(param);
          setEmployeeId(decoded?.user_id);
        } catch {
          setEmployeeId(null);
        }
      } else {
        setEmployeeId(param);
      }
    } else {
      setEmployeeId(users?.user_id);
    }
  }, [users, param]);

  const { data: fetchedData, refetch: corefocus_details } = useFetchCoreFocusAreasQuery(employeeId, {
    skip: !employeeId,
  });

  const [createCoreFocusArea] = useCreateCoreFocusAreaMutation();

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      coreFocusAreas: [{ id: null, area: "", timeSpent: "", importance: "" }],
    },
    resolver: yupResolver(validationSchema),
  });

  const { append, fields, remove } = useFieldArray({
    control,
    name: "coreFocusAreas",
  });

  // populate form with backend data
  useEffect(() => {
    if (fetchedData) {
      reset({ coreFocusAreas: [] });
      const coreFocusArray = fetchedData?.data || [];
      const transformedData = coreFocusArray.map((area) => ({
        id: area.id ?? null,
        area: area.area || "",
        timeSpent: area.time_spent || 0,
        importance: area.importance || 0,
      }));
      transformedData.forEach((data) => append(data));
    }
  }, [fetchedData, append, reset]);

  useEffect(() => {
    if (currentStep === 2 && employeeId) {
      corefocus_details();
    }
  }, [currentStep, employeeId, corefocus_details]);

  const onSubmit = async (data) => {
    const coreFocusAreas = watch("coreFocusAreas");
    const totalTimeSpent = coreFocusAreas.reduce(
      (sum, area) => sum + (parseFloat(area.timeSpent) || 0),
      0
    );
    const totalImportance = coreFocusAreas.reduce(
      (sum, area) => sum + (parseFloat(area.importance) || 0),
      0
    );

    if (totalTimeSpent !== 100 || totalImportance !== 100) {
      console.warn("Time Spent and Importance must sum to 100%");
      return;
    }

    // include id if present
    const payload = data.coreFocusAreas.map((area) => ({
      id: area.id ?? null,
      area: area.area,
      user_id: Number(employeeId),
      time_spent: Number(area.timeSpent),
      importance: Number(area.importance),
    }));

    const response = await createCoreFocusArea(payload);
    const coreFocusAreasData = response.data?.data || [];
    onNext({ coreFocusAreas: coreFocusAreasData });
  };

  const saveDataToBackend = async () => {
    const coreFocusAreas = watch("coreFocusAreas");
    const payload = coreFocusAreas.map((area) => ({
      id: area.id ?? null,
      area: area.area,
      user_id: Number(employeeId),
      time_spent: Number(area.timeSpent),
      importance: Number(area.importance),
    }));
    try {
      await createCoreFocusArea(payload);
    } catch (error) {
      console.error("Error saving Core Focus Areas:", error);
    }
  };

  const handlePrevious = async () => {
    await saveDataToBackend();
    onPrev();
  };
// ++++++++++++++++++++++++++++ with modify corefocus area name ++++++++++++++++++++++++++++
  // const { append, fields ,remove} = useFieldArray({
  //   control,
  //   name: "coreFocusAreas",
  // });
  const coreFocusAreas = watch("coreFocusAreas");

  const totalTimeSpent = coreFocusAreas.reduce(
    (sum, area) => sum + (parseFloat(area.timeSpent) || 0),
    0
  );
  const totalImportance = coreFocusAreas.reduce(
    (sum, area) => sum + (parseFloat(area.importance) || 0),
    0
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormLastBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
        <RowWrap>
          <Col12Wrap>
            <FormGroupWrap>
              <CustomHead>
              What are the Core Focus Areas of your job? 
              </CustomHead>
            </FormGroupWrap>
          </Col12Wrap>
          <Col12Wrap>
            <FormGroupWrap sx={{ marginBottom: "0"}}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "end",
                  columnGap: "10px",
                  marginBottom: "10px",
                }}
              >
                <Box width={{ width: "calc(100% - 220px)" }}>
                  <FormLabelWrap
                    sx={{
                      fontSize: "20px",
                      color: "#7C7C7C",
                      letterSpacing: "0.3px",
                      marginBottom: "0px",
                      maxWidth: "450px",
                    }}
                  >
                    Define the Core Focus Areas or key elements/aspects of your job.  These are the primary 3-7 "buckets" of work you perform. Please list them in order of importance - then break out your time spent and how important you perceive each one to be.
                  </FormLabelWrap>
                   <FormLabelWrap
                    sx={{
                      fontSize: "20px",
                      color: "#7C7C7C",
                      letterSpacing: "0.3px",
                      marginBottom: "10px",
                    }}
                  >
                    If needed, there is a short video to guide you.{" "}
                    <Link
                      to="https://youtu.be/f9HCBD1uobI"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: "#1976d2", textDecoration: "underline", fontWeight: "bold" }}
                    >
                      Click here to watch video
                    </Link>
                  </FormLabelWrap>
                </Box>
                <Box sx={{ width: "100px" }}>
                  <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
                    Time Spent
                  </FormLabelWrap>
                </Box>
                <Box sx={{ width: "100px" }}>
                  <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
                    Importance
                  </FormLabelWrap>
                </Box>
              </Box>
              {fields.map((area, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "flex-start",
                    columnGap: "10px",
                    marginBottom: "10px",
                    position:"relative"

                  }}
                >
                  <Box width={{ width: "calc(100% - 220px)" }}>
                    <CustomTextField
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "10px 20px",
                        },
                      }}
                      variant="outlined"
                      {...register(`coreFocusAreas.${index}.area`)} 
                        error={!!errors?.coreFocusAreas?.[index]?.area}
                        // helperText={errors?.coreFocusAreas?.[index]?.area?.message}
                      placeholder="Area"
                    />
                    {errors?.coreFocusAreas?.[index]?.area && (
                      <ErrorText>
                        {errors?.coreFocusAreas?.[index]?.area?.message}
                      </ErrorText>
                    )}
                  </Box>
                  <Box sx={{ width: "100px" }}>
                    <CustomTextField
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "10px 20px",
                          textAlign: "right",
                        },
                      }}
                      variant="outlined"
                      {...register(`coreFocusAreas.${index}.timeSpent`)}
                      placeholder="20%"
                      //   error={!!errors?.coreFocusAreas?.[index]?.timeSpent}
                      //   helperText={errors?.coreFocusAreas?.[index]?.timeSpent?.message}
                    />
                    {errors?.coreFocusAreas?.[index]?.timeSpent && (
                      <ErrorText>
                        {errors?.coreFocusAreas?.[index]?.timeSpent?.message}
                      </ErrorText>
                    )}
                  </Box>
                  <Box sx={{ width: "100px" }}>
                    <CustomTextField
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "10px 20px",
                          textAlign: "right",
                        },
                      }}
                      variant="outlined"
                      {...register(`coreFocusAreas.${index}.importance`)}
                      placeholder="20%"
                      //   placeholder="20%"
                      //   error={!!errors?.coreFocusAreas?.[index]?.importance}
                      //   helperText={errors?.coreFocusAreas?.[index]?.importance?.message}
                    />
                    {errors?.coreFocusAreas?.[index]?.importance && (
                      <ErrorText>
                        {errors?.coreFocusAreas?.[index]?.importance?.message}
                      </ErrorText>
                    )}
                  </Box>
                  <Box sx={{ width: "100px", display: "flex", justifyContent: "center" }}>
  
  <CustomBtn
    type="button"
    onClick={() => remove(index)} // Remove the item by index
    variant="outlined"
    sx={{
      fontSize: "5px",
      fontWeight: "600",
      color: "#E75B5B",
      borderColor: "#F0F0F0",
      borderRadius: "7px",
      background: "#F0F0F0",
      // padding: "5px",
      position: "absolute",
      top: "9px",
      right: "-30px",
      width: "25px",
      height: "25px",
      minWidth: "0",
      padding: "6px",
       // Adjust padding for a compact button
      "& svg": {
        margin: "0", // Remove extra margin around the icon
      },
    }}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L15 15M15 1L1 15"
        stroke="#E75B5B"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </CustomBtn>
</Box>
                </Box>
              ))}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  columnGap: "10px",
                  marginBottom: "10px",
                }}
              >
                
                <Box width={{ width: "calc(100% - 220px)" }}>
                  <CustomBtn
                    type="button"
                    onClick={() =>
                      append({ area: "", timeSpent: "", importance: "" })
                    }
                    variant="outlined"
                    sx={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#1085AB",
                      borderColor: "#F0F0F0",
                      borderRadius: "7px",
                      background: "#F0F0F0",
                      maxWidth: "90px",
                      padding: "10px 10px",
                      "& svg": {
                        marginRight: "8px",
                      },
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.10767 1L8.10767 15"
                        stroke="#F28021"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M1 8.18335L15 8.18335"
                        stroke="#F28021"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>{" "}
                    Add
                  </CustomBtn>
                </Box>
                <Box sx={{ width: "100px" }}>
                  <FormLabelWrap
                    sx={{
                      fontSize: "16px",
                      fontWeight: "500",
                      textAlign: "center",
                      marginBottom: "0",
                    }}
                  >
                    {totalTimeSpent}%
                    {totalTimeSpent > 100 && (
  <ErrorText>Total TimeSpent percentage cannot exceed 100%!</ErrorText>
)}
{totalTimeSpent < 100 && (
  <ErrorText>Total TimeSpent percentage cannot under 100%!</ErrorText>
)}
                  </FormLabelWrap>
                </Box>
                <Box sx={{ width: "100px" }}>
                  <FormLabelWrap
                    sx={{
                      fontSize: "16px",
                      fontWeight: "500",
                      textAlign: "center",
                      marginBottom: "0",
                    }}
                  >
                    {totalImportance}%
                    {totalImportance > 100 && (
  <ErrorText>Total Importance percentage cannot exceed 100%!</ErrorText>
)}
{totalImportance < 100 && (
  <ErrorText>Total Importance percentage cannot under 100%!</ErrorText>
)}
                  </FormLabelWrap>
                </Box>
              </Box>
            </FormGroupWrap>
          </Col12Wrap>
        </RowWrap>
      </FormLastBoxWrap>
      <FormBtnBoxWrap>
        <RowWrap>
          <Col12Wrap sx={{ textAlign: "center" }}>
              <CustomBtn
            type="button"
            variant="outlined"
            sx={{
              marginRight: "10px", // Add spacing between buttons
              "& svg": { marginRight: "10px" },
            }}
            onClick={handlePrevious} // Call the onPrev function on click
          >
            <svg
              width="15"
              height="16"
              viewBox="0 0 15 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9L14 7ZM0.292893 8.70711C-0.0976311 8.31658 -0.097631 7.68342 0.292893 7.29289L6.65685 0.928932C7.04738 0.538407 7.68054 0.538407 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292893 8.70711ZM14 9L1 9L1 7L14 7L14 9Z"
                fill="white"
              />
            </svg>
            Previous
          </CustomBtn>
            <CustomBtn
              type="submit"
              variant="outlined"
              sx={{ "& svg": { marginLeft: "10px" } }}
            >
              Next
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289L8.34315 0.928932C7.95262 0.538407 7.31946 0.538407 6.92893 0.928932C6.53841 1.31946 6.53841 1.95262 6.92893 2.34315L12.5858 8L6.92893 13.6569C6.53841 14.0474 6.53841 14.6805 6.92893 15.0711C7.31946 15.4616 7.95262 15.4616 8.34315 15.0711L14.7071 8.70711ZM1 9L14 9L14 7L1 7L1 9Z"
                  fill="white"
                />
              </svg>
            </CustomBtn>
          </Col12Wrap>
        </RowWrap>
      </FormBtnBoxWrap>
    </form>
  );
};

export default Step2;

const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormLastBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  borderRadius: "0px 0px 7px 7px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const FormBtnBoxWrap = styled(Box)(() => ({
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30px",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
  },
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "30px",
  position: "relative",
}));
const FormLabelWrap = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: "400",
  
  lineHeight: "1.445",
  color: "#2C2C2E",
  marginBottom: "5px",
}));
const CustomTextField = styled(TextField)(({error = false}) => ({
  width: "100%",
  border: error?"1px solid rgb(210, 33, 33)":"1px solid #DADADA",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#2C2C2E",
    padding: "14px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const CustomHead = styled(Typography)(() => ({
  fontSize: "26px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#1085AB",
  "@media (max-width: 575px)": {
    fontSize: "22px",
  },
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "22px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  // padding: "19px 20px",
  // maxWidth: "300px",
  maxWidth: "150px",
  padding: "10px 15px",
  boxShadow: "none !important",
}));

